<template>
  <v-layout column style="width: 100%;">
    <v-layout row>
      <v-flex lg3 md4 sm6>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDate"
              label="Date"
              prepend-icon="event"
              readonly
              v-on="on"
              dense
            ></v-text-field>
          </template>
          <v-date-picker no-title v-model="startDate" @input="menu = false"></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <GChart
      @ready="onTimelineReady"
      :settings="{ packages: ['corechart', 'table', 'map', 'timeline'] }"
      type="Timeline"
      :options="timelineOptions"
    />
  </v-layout>
</template>

<script>
import moment from "moment";
import { GChart } from "vue-google-charts";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "planner",
  components: {
    GChart
  },
  props: {
    driverPlanner: Object
  },
  watch: {
    startDate: function() {
      // this.getWorkingHours();
    },
    endDate: function() {
      // this.getWorkingHours();
    }
  },
  data() {
    return {
      timeGaps: null,
      chart: null,
      timeline: null,
      menu: false,
      menu2: false,
      chartData: null,
      chartOptions: {
        chart: {
          title: "Hours Worked"
        },
        colors: ["#03A9F4", "#009688", "#FFEB3B", "#795548"],
        width: "100%",
        height: 400,
        legend: { position: "top", maxLines: 3 },
        bar: { groupWidth: "90%" },
        isStacked: true,
        axes: {
          y: {
            0: { side: "left", label: "No. Of Hours" } // Top x-axis.
          }
        }
      },
      timelineOptions: {
        width: "100%",
        height: 300,
        timeline: { colorByRowLabel: true }
      },
      chartEvents: {
        select: () => {
          console.log(this.chart.getSelection());

          if (this.chart.getSelection()[0] == null) {
            return;
          }

          var row = this.chart.getSelection()[0].row;

          this.getStateBreakdownForDay(row);
        }
      },
      startDate: moment()
        .startOf("day")
        .add(1, "days")
        .toDate()
        .toISOString()
        .substr(0, 10)
    };
  },
  mounted: function() {
    this.getWorkingHours();
  },
  methods: {
    onTimelineReady(timeline, google) {
      this.timeline = timeline;
      this.getStateBreakdownForDay(0);
    },
    getStateBreakdownForDay() {
      var start = moment(this.startDate, "YYYY-MM-DD");
      this.getStateBreakdown(start);
    },
    workingOnThisDay(date, driverPlanner) {
      // TODO
      // check day of week, and day off!
      return true;
    },
    splitTime(time) {
      var hm = time.split(":");

      return {
        hour: parseInt(hm[0]),
        minute: parseInt(hm[1])
      };
    },
    getStateBreakdown(start) {
      console.log(start);

      var events = [];

      for (var i = 0; i < 7; i++) {
        var date = start.clone().add(i, "days");

        if (!this.workingOnThisDay(date, this.driverPlanner)) {
          continue;
        }

        var startTime = this.splitTime(this.driverPlanner.hourPeriodStart);
        var endTime = this.splitTime(this.driverPlanner.hourPeriodEnd);

        var startDate = date
          .clone()
          .set({ hour: startTime.hour, minute: startTime.minute });
        var endDate = date
          .clone()
          .set({ hour: endTime.hour, minute: endTime.minute });

        events.push({
          name: "Core Hours",
          start: startDate,
          end: endDate
        });

        for (var j = 0; j < this.driverPlanner.breaks.length; j++) {
          var brk = this.driverPlanner.breaks[j];

          var brkStartTime = this.splitTime(brk.hourPeriodStart);
          var brkEndTime = this.splitTime(brk.hourPeriodEnd);

          var breakStartDate = date
            .clone()
            .set({ hour: brkStartTime.hour, minute: brkStartTime.minute });
          var breakEndDate = date
            .clone()
            .set({ hour: brkEndTime.hour, minute: brkEndTime.minute });

          events.push({
            name: "Break " + j,
            start: breakStartDate,
            end: breakEndDate
          });
        }
      }

      if (this.driverPlanner.privateTrips != null) {
        for (var i = 0; i < this.driverPlanner.privateTrips.length; i++) {
          var privateTrip = this.driverPlanner.privateTrips[i];

          var startDate = moment(privateTrip.startDate, "YYYY-MM-DD HH:mm");

          var endDate = moment(privateTrip.endDate, "YYYY-MM-DD HH:mm");

          events.push({
            name: "Private Trip " + i,
            start: startDate,
            end: endDate
          });
        }
      }

      if (this.driverPlanner.upcomingPreassignments != null) {
        for (
          var i = 0;
          i < this.driverPlanner.upcomingPreassignments.length;
          i++
        ) {
          var preassignedTrip = this.driverPlanner.upcomingPreassignments[i];

          var startDate = moment(
            preassignedTrip.pickupTime,
            "YYYY-MM-DD HH:mm"
          );

          var endDate = moment(preassignedTrip.finishTime, "YYYY-MM-DD HH:mm");

          events.push({
            name: "Preassigned Trip #" + preassignedTrip.id,
            id: preassignedTrip.id,
            start: startDate,
            end: endDate
          });
        }
      }

      console.log("EVENTS");
      console.log(events);

      // Step 1 is iterate all the events and filter out those that are relevant.
      // also combine all events into one big array?

      // this will involve parsing a lot of dates so maybe inefficient

      // then filter out events that overlap our date

      // add row for

      // working hours
      // breaks
      // preassigned work
      // private trips
      // days off
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
